<div class="grid-timelist-wrapper">
  <div class="grid-row-1-col-1">
    <app-date-selector (changeDate)="dateChanged($event)" 
      [selectedDate]="initDate" 
      [tabsDateRangeSelectedIndex]="selectedDateRangeIndex" 
      (rangeSelectedIndexChanged)="selectedDateRangeIndex = $event" 
      [showInterval]="true"
      [setDisableSelector]="isLoading">
    </app-date-selector>
  </div>
  <div *ngIf="showEmployeeSelect === true" class="grid-row-2-col-1">
    <dx-select-box [height]="45" [dataSource]="employeeDataSource" displayExpr="FullName" [placeholder]="placeholderEmployeeSelect"
                   valueExpr="EmployeeId" [(value)]="selectedEmployeeId" [visible]="showEmployeeSelect"
                   [showClearButton]="true" (onSelectionChanged)="onSelectionChangedEmployees($event)">
    </dx-select-box>
  </div>
</div>

<dx-data-grid class="pointer mat-elevation-z3" style="padding: 20px;margin-right:20px;" [dataSource]="dataSource"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                (onCellPrepared)="onCellPrepared($event)"
                (onExporting)="onExporting($event)">
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-column-chooser [enabled]="true" [title]="this.languageService.LNG('dxAllAms.dxDataGrid-columnChooserTitle')"></dxo-column-chooser>
        <dxi-column dataField="StatusId" [caption]="" [width]="30" cellTemplate="statusCellTemplate" calculateSortValue="StatusId" calculateGroupValue="StatusDescription" [allowExporting]="false" >
          <dxo-header-filter [dataSource]="statusFilterData"></dxo-header-filter>
        </dxi-column>
        <dxi-column dataField="Employee" [caption]="this.languageService.LNG('Label.Employee')"   ></dxi-column>
        <dxi-column dataField="EmployeeNumber" [caption]="this.languageService.LNG('Label.EmployeeNumber')" [visible]="false"></dxi-column>
        <dxi-column dataField="EmployeeName" [caption]="this.languageService.LNG('Label.EmployeeName')" [visible]="false"></dxi-column>
        <dxi-column dataField="EmployeeDepartment" [caption]="this.languageService.LNG('Label.Employee.Department.Short')"   ></dxi-column>
        <dxi-column dataField="Date_YYYYMMDD" [caption]="this.languageService.LNG('Label.Date')" groupCellTemplate="dateGroupTemplate" cellTemplate="dateCellTemplate"  [calculateSortValue]="customDateSort"  sortOrder="asc"   ></dxi-column>
        <dxi-column dataField="Date_MMYYYY" [caption]="this.languageService.LNG('Label.Month')"   ></dxi-column>
        <dxi-column dataField="Project" [caption]="this.languageService.LNG('Label.Project')"   ></dxi-column>
        <dxi-column dataField="TimeDepartment" [caption]="this.languageService.LNG('Label.Department')"   ></dxi-column>
        <dxi-column dataField="ProjectActivityNumber" [caption]="textProjectActivityNumber" [visible]="showProjectActivityColumn" ></dxi-column>
        <dxi-column dataField="ProjectActivityName" [caption]="textProjectActivityName" [visible]="showProjectActivityColumn" ></dxi-column>
        <dxi-column dataField="Customer" [caption]="this.languageService.LNG('Label.Customer')" [visible]="showCustomerColumn"></dxi-column>
        <dxi-column dataField="StartTime" dataType="date" format="dd.MM.yyyy HH:mm" [caption]="this.languageService.LNG('Label.Start')"></dxi-column>
        <dxi-column dataField="StopTime" dataType="date" format="dd.MM.yyyy HH:mm" [caption]="this.languageService.LNG('Label.Stop')"></dxi-column>
        <dxi-column dataField="TotSecondsToHHmm" [caption]="this.languageService.LNG('Label.Hours.Minutes.Short')"   ></dxi-column>
        <dxi-column dataField="TotSecondsAsHours" [caption]="this.languageService.LNG('Label.Hours')"   >
          <dxo-format
              type="fixedPoint"
              [precision]="2"
          ></dxo-format>
        </dxi-column>
        <dxi-column dataField="TimeTypeCode" [caption]="this.languageService.LNG('Label.TimeType')"   ></dxi-column>
        <dxi-column dataField="Comment" [caption]="this.languageService.LNG('Label.Comment')" [width]="200"  ></dxi-column>

      <div *dxTemplate="let cell of 'statusCellTemplate'">
        <fa-icon *ngIf="maxStatusIdLockOpen > -1 && cell.data.StatusId <= maxStatusIdLockOpen" [icon]="faLockOpen" ></fa-icon>
        <fa-icon *ngIf="minStatusIdLock > -1 && cell.data.StatusId >= minStatusIdLock && cell.data.StatusId <= maxStatusIdLock" [icon]="faLock" ></fa-icon>
        <fa-icon *ngIf="minStatusIdEnvelope > -1 && cell.data.StatusId >= minStatusIdEnvelope" [icon]="faEnvelope" ></fa-icon>
      </div>
      <div *dxTemplate="let data of 'dateCellTemplate'">
        <span>{{data.data.Date_Str}}</span>
      </div>
      <div *dxTemplate="let data of 'dateGroupTemplate'">
        <span>{{groupTemplate(data)}}</span>
      </div>

    <dxo-summary [calculateCustomSummary]="calculateSummary">
      <dxi-total-item
        name="customSumHours"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="TotSecondsToHHmm">
      </dxi-total-item>
      <dxi-group-item
        name="customSumHours"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="TotSecondsToHHmm">
      </dxi-group-item>
      <dxi-total-item
        name="customSumHoursDecimal"
        summaryType="custom"
        displayFormat="{0}"
        showInColumn="TotSecondsAsHours">
      </dxi-total-item>
      <dxi-group-item
        name="customSumHoursDecimal"
        summaryType="custom"
        alignByColumn="true"
        showInColumn="TotSecondsAsHours">
      </dxi-group-item>
    </dxo-summary>
</dx-data-grid>
